/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

riot.mixin('spcmixin', {
	init: function() {
		var update = function() {
			var comps = this.root.querySelectorAll('[class*="spc-js-"');
			if (comps.length > 0) {
				window.componentHandler.upgradeElements(comps);
			}
		}.bind(this);

		riotctrl.once('update-spcmixin-retro', function() {
			this.on('mount update updated', update);
			update();
		}.bind(this));
	}
});
